import React from "react";
import { Outlet } from "react-router-dom";
import Safearea from "../../components/include/Safearea";

export default function AdmIndex() {
  return (
    <Safearea>
      <Outlet />
    </Safearea>
  );
}
